module.exports = [
    {
        numero: 2,
        iva:' N/A',
    },
    {
        numero: 3,
        iva:' N/A',
    },
    {
        numero: 4,
        iva:' N/A',
    },
    {
        numero: 5,
        iva:'N/A',
    },
    {
        numero: 6,
        iva:'N/A',
    },
    {
        numero: 7,
        iva:'N/A',
    },
    {
        numero: 8,
        iva:'8%',
    },
    
    {
        numero: 9,
        iva:'8%',
    },
    
    {
        numero: 10,
        iva:'8%',
    },
    
    {
        numero: 11,
        iva:'8%',
    },
    {
        numero: 12,
        iva:'N/A',
    },
    {
        numero: 13,
        iva:'8%',
    },
    
    {
        numero: 14,
        iva:'8%',
    },
    
    {
        numero: 15,
        iva:'8%',
    },
    {
        numero: 16,
        iva:'N/A',
    },
    
    {
        numero: 17,
        iva:'8%',
    },
    
    {
        numero: 18,
        iva:'8%',
    },
    
    {
        numero: 19,
        iva:'8%',
    },
    
    {
        numero: 20,
        iva:'8%',
    },
    
    {
        numero: 21,
        iva:'8%',
    },
    
    {
        numero: 22,
        iva:'8%',
    },
    
    {
        numero: 23,
        iva:'8%',
    },
    
    {
        numero: 24,
        iva:'8%',
    },
    
    {
        numero: 25,
        iva:'N/A',
    },
    
    {
        numero: 26,
        iva:'8%',
    },
    
    {
        numero: 27,
        iva:'N/A',
    },
    
    {
        numero: 28,
        iva:'N/A',
    },
    
    {
        numero: 29,
        iva:'N/A',
    },
    
    {
        numero: 30,
        iva:'8%',
    },
    
    {
        numero: 31,
        iva:'8%',
    },
    
    {
        numero: 32,
        iva:'N/A',
    },

    {
        numero: 33,
        iva:'8%',
    },
    
    {
        numero: 34,
        iva:'8%',
    },
    
    {
        numero: 35,
        iva:'8%',
    },
    
    {
        numero: 36,
        iva:'8%',
    },
    {
        numero: 37,
        iva:'8%',
    },
    
    {
        numero: 38,
        iva:'8%',
    },
    
    {
        numero: 39,
        iva:'8%',
    },
    
    {
        numero: 40,
        iva:'8%',
    },
    {
        numero: 41,
        iva:'8%',
    },
    
    {
        numero: 42,
        iva:'8%',
    },
    
    {
        numero: 43,
        iva:'8%',
    },
    
    {
        numero: 44,
        iva:'8%',
    },
    {
        numero: 45,
        iva:'N/A',
    },
    
    {
        numero: 46,
        iva:'8%',
    },
    
    {
        numero: 47,
        iva:'8%',
    },
    
    {
        numero: 48,
        iva:'8%',
    },
    {
        numero: 49,
        iva:'8%',
    },
    
    {
        numero: 50,
        iva:'8%',
    },
    
    {
        numero: 51,
        iva:'8%',
    },
    
    {
        numero: 52,
        iva:'8%',
    },
    {
        numero: 53,
        iva:'8%',
    },
]


// WEBPACK FOOTER //
// ./src/utils/impoIva.js